import React, {useContext, useState} from "react";
import Master from "./Components/Pages/Home/Master";
import AlbumContent from "./Components/Pages/Home/Album/AlbumContent"
import {ThemeProvider,createTheme} from "@mui/material";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import HomeContent from "./Components/Pages/Home/Main/HomeContent"
import ArtistContent from "./Components/Pages/Home/Artist/ArtistContent";
import SongContent from "./Components/Pages/Home/Song/SongContent";
import PodcastContent from "./Components/Pages/Home/Podcast/PodcastContent";
import AudioBookContent from "./Components/Pages/Home/AudioBook/AudioBookContent";
import PlayListContent  from "./Components/Pages/Home/PlayList/PlayListContent";
import PlaylistContext from "./Components/Context/PlaylistContext";
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import Browse from "./Components/Pages/Home/Browse";
import Search from './Components/Pages/Home/Search'

function App() {
    const THEME = createTheme({
        direction: 'rtl',
        typography: {
            "fontFamily": `"IRANSans", "Helvetica", "Arial", sans-serif`,
        }
    });
    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [prefixer, rtlPlugin],
    });

    const [playlist, setPlaylist] = useState([
        {
            name: 'اینترو',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/01.Hiphopologist%20-%20Intro%20%28320%29.mp3',
            id: 1,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg',
            time: '3:25'
        },
        {
            name: 'ادی',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/02.Hiphopologist%20-%20OD%20%28320%29.mp3',
            id: 2,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'سادیسم',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/03.Hiphopologist%20-%20Sadism%20%28320%29.mp3',
            id: 3,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'نورف نورف',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/04.Hiphopologist%20-%20Norf%20Norf%20%28320%29.mp3',
            id: 4,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'دریا کنار',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/05.Hiphopologist%20-%20Daryakenar%20%28320%29.mp3',
            id: 5,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'شیش',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/06.Hiphopologist%20-%20Sheesh%20%28320%29.mp3',
            id: 6,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'آدامس',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/07.Hiphopologist%20%26%20Shayan%20Rag%20-%20Adams%20Skit%20%28320%29.mp3',
            id: 7,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'داستان',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/08.Hiphopologist%20%26%20021Kid%20-%20Dastan%20%28320%29.mp3',
            id: 8,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'بانک',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/09.Hiphopologist%20%26%20Catchy%20Beatz%20-%20Bank%20%28320%29.mp3',
            id: 9,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'یالا',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/10.Hiphopologist%20-%20Yallah%20%28320%29.mp3',
            id: 10,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'ترپ لایف',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/11.Hiphopologist%20%26%20Behzad%20Leito%20-%20Traplife%20%28320%29.mp3',
            id: 11,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'دیاز',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/12.Hiphopologist%20-%20Diaz%20Skit%20%28320%29.mp3',
            id: 12,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'دی ام تی',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/13.Hiphopologist%20-%20DMT%20%28320%29.mp3',
            id: 13,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'با تو',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/15.Hiphopologist%20%26%20Sinazza%20-%20Rotation%20%28320%29.mp3',
            id: 14,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'روتیشن',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/16.Hiphopologist%20%26%20Dehghan%20-%20Bache%20-%20Bad%20B%20%28320%29.mp3',
            id: 15,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'بد بی',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/16.Hiphopologist%20%26%20Dehghan%20-%20Bache%20-%20Bad%20B%20%28320%29.mp3',
            id: 16,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'بچه',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/17.Hiphopologist%20-%20Bache%20%28320%29.mp3',
            id: 17,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'شیر',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/18.Hiphopologist%20-%20Shir%20%28320%29.mp3',
            id: 18,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
        {
            name: 'ریه',
            time: '3:25',
            link: 'https://dl.solahang.com/Album/1402/04/H/320/19.Hiphopologist%20-%20Rie%20%28320%29.mp3',
            id: 19,
            artistName: 'هیپهاپولوژیست',
            image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
        },
    ]);
    const value = { playlist, setPlaylist };

  return (
      <PlaylistContext.Provider value={value}>
          <CacheProvider value={cacheRtl}>
          <ThemeProvider  theme={THEME}>
              <BrowserRouter>
                  <Routes>
                      <Route path='/' element={<Master/>}>
                          <Route path='/' element={<HomeContent/>} />
                          <Route path='album/:id' element={<AlbumContent/>} />
                          <Route path='artist/:id' element={<ArtistContent/>} />
                          <Route path='song/:id' element={<SongContent/>} />
                          <Route path='podcast/:id' element={<PodcastContent/>} />
                          <Route path='audio-book/:id' element={<AudioBookContent/>} />
                          <Route path='play-list/:id' element={<PlayListContent/>} />
                          <Route path='browse' element={<Browse/>} />
                          <Route path='search' element={<Search/>} />
                      </Route>
                  </Routes>
              </BrowserRouter>
          </ThemeProvider >
              </CacheProvider>
      </PlaylistContext.Provider>

  );
}

export default App;
